<template>
    <div id="groupChat" class="card-container" v-if="show">
        <template v-if="currDetailStatus.status === 0">
            <div class="tab_title margin_bottom_15">
                <a-alert :message="message" type="info" />
            </div>
            <a-button type="primary" class="tab_btn" @click="toDetail(1)">
                新建客户群码
            </a-button>
            <a-divider />
            <!-- 客户群码列表 -->
            <div class="staff_list">
                <div class="table_data">
                    <a-table
                        rowKey="id"
                        :columns="qrcodeColumns"
                        :data-source="qrcodeList"
                        :pagination="qrcodePage"
                        :scroll="{ y: 536 }"
                        @change="changePagination"
                    >
                        <template slot="qrcode" slot-scope="text, record">
                            <a-tooltip placement="right">
                                <template slot="title">
                                    <createQrcode
                                        :downloadShow="false"
                                        :data="record.qrcodeData"
                                        style="width:100%;"
                                    ></createQrcode>
                                </template>
                                <createQrcode
                                    :downloadShow="false"
                                    :data="record.qrcodeData"
                                    style="width:30px;height:30px;"
                                ></createQrcode>
                            </a-tooltip>
                            <!-- <img :src="record.logo" crossorigin="anonymous" v-if="record.logo" width="30" /> -->
                        </template>
                        <template slot="name" slot-scope="text, record">
                            <div class="base_font_color_ff5800" style="cursor: pointer;" @click="toDetail(2, record)">{{
                                text
                            }}</div>
                        </template>
                        <template slot="scene" slot-scope="text">
                            <div class="btn">{{ text }}</div>
                        </template>
                        <template slot="number" slot-scope="text">
                            <div class="btn">{{ text }}</div>
                        </template>
                        <template slot="owner" slot-scope="text">
                            <div class="btn">
                                <openData type="userName" :openid="text"></openData>
                            </div>
                        </template>
                        <template slot="action" slot-scope="text, record">
                            <a-button-group style="margin-left: -7px;" class="cross_center">
                                <!-- <a-button
                                    type="link"
                                    size="small"
                                    @click="downloadImg(record)"
                                    >下载</a-button
                                > -->
                                <createQrcode
                                    downloadButtonSize="small"
                                    downloadButtonName="下载"
                                    :qrcodeShow="false"
                                    :fileName="record.name"
                                    :data="record.qrcodeData"
                                ></createQrcode>
                                <a-divider type="vertical" />
                                <a-button type="link" size="small" @click="toDetail(3, record)"
                                    >管理聊天群</a-button
                                >
                            </a-button-group>
                        </template>
                    </a-table>
                </div>
            </div>
        </template>
        <template v-else>
            <!-- 详情 -->
            <a-page-header
                :title="currDetailStatus.name"
                @back="createBack(currDetailStatus)"
                class="edit_code_title margin_bottom_15"
            />
            <template v-if="currDetailStatus.status === 3 || currDetailStatus.status === 5">
                <!-- 管理群聊 -->
                <groupChatManage
                    :currQcrode="currQcrode"
                    :show="currDetailStatus.show"
                ></groupChatManage>
            </template>
            <template v-else-if="currDetailStatus.status === 2">
                <!-- 群活码详情 -->
                <groupDetail
                    :currQcrode="currQcrode"
                    :status="currDetailStatus"
                    @backStatus="backStatus"
                    @toChat="toChat"
                ></groupDetail>
            </template>
            <template v-else-if="currDetailStatus.status === 4">
                <!-- 编辑群活码 -->
                <groupDetailEdit
                    type="update"
                    :currQcrode="currQcrode"
                    :status="currDetailStatus"
                    @toChat="toChat"
                ></groupDetailEdit>
            </template>
            <template v-else-if="currDetailStatus.status === 1">
                <!-- 新建群活码 -->
                <groupQrcodeCreate :status="currDetailStatus" @toChat="toChat"></groupQrcodeCreate>
            </template>
        </template>
    </div>
</template>

<script>
import api from '@/apis';
import _ from 'lodash';
import openData from '@/components/group/openData';
import groupChatManage from '@/components/group/groupChatManage';
import groupDetail from '@/components/group/groupDetail';
import groupDetailEdit from '@/components/group/groupDetailEdit';
import groupQrcodeCreate from '@/components/group/groupQrcodeCreate';
import createQrcode from '@/components/group/createQrcode';
export default {
    props: {
        show: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        message: {
            type: String,
            default: function() {
                return '';
            }
        }
    },
    components: {
        openData,
        groupChatManage,
        groupDetail,
        groupDetailEdit,
        groupQrcodeCreate,
        createQrcode
    },
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASEURL,
            qrcodeUrl: process.env.VUE_APP_DEFAULT + '/html/tool/qrcode?groupId=',
            headers: {},
            // 客户群码列表
            qrcodeColumns: [
                {
                    title: '群码',
                    dataIndex: 'qrcode',
                    scopedSlots: { customRender: 'qrcode' }
                },
                {
                    title: '活动名称',
                    dataIndex: 'name',
                    scopedSlots: { customRender: 'name' }
                },
                {
                    title: '活动场景',
                    dataIndex: 'scene',
                    scopedSlots: { customRender: 'scene' }
                },
                {
                    title: '群聊数',
                    dataIndex: 'number',
                    scopedSlots: { customRender: 'number' }
                },
                {
                    title: '创建人',
                    dataIndex: 'owner',
                    scopedSlots: { customRender: 'owner' }
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                    width: 200
                }
            ],
            qrcodeParams: {
                page: 1,
                keywords: null
            },
            qrcodeList: [],
            qrcodePage: {
                total: 0,
                pageSize: 10
            },
            // 依据详情状态 ，判断当前界面场景 0:客户群码列表;1:新建群活码;2:群活码详情;3/5:管理群聊;4:编辑群活码
            currDetailStatus: {
                status: 0,
                name: '客户群码列表',
                backStatus: null,
                desc: ''
            },
            // 当前群码信息
            currQcrode: {},
            // backStatus返回的状态，指明当前界面返回上级的界面
            detailStatus: [
                {
                    status: 0,
                    name: '客户群码列表',
                    backStatus: null,
                    desc: ''
                },
                {
                    status: 1,
                    name: '新建群活码',
                    backStatus: 0,
                    desc: ''
                },
                {
                    status: 2,
                    name: '群活码详情',
                    backStatus: 0,
                    desc: '',
                    show: false
                },
                {
                    status: 3,
                    name: '管理群聊',
                    backStatus: 0,
                    desc:
                        '微信群超过200人只能邀请进群，当群人数达到190人时，将自动切换成下一个群二维码。',
                    show: false
                },
                {
                    status: 4,
                    name: '编辑群活码',
                    backStatus: 2,
                    desc: '',
                    show: false
                },
                {
                    status: 5,
                    name: '管理群聊',
                    backStatus: 2,
                    desc:
                        '微信群超过200人只能邀请进群，当群人数达到190人时，将自动切换成下一个群二维码。',
                    show: false
                }
            ]
        };
    },
    created() {},
    computed: {},
    mounted() {
        if (this.show) {
            this.getGroupQrcodeList();
        }
    },
    watch: {},
    methods: {
        // 获取客户群码列表
        async getGroupQrcodeList() {
            try {
                const res = await api.getGroupQrcodeList(this.qrcodeParams);
                if (res.code !== 0) return this.$message.error(`获取客户群码列表报错`);
                res.rows.forEach((item) => {
                    // 赋值二维码参数
                    item.qrcodeData = {
                        qid: item.groupId,
                        correctLevel: 3,
                        text: this.qrcodeUrl + item.groupId,
                        logoScale: 0.2,
                        logoMargin: 2,
                        size: 300,
                        margin: 10
                    };
                    if (item.logo) item.qrcodeData.logoSrc = item.logo;
                    return item;
                });
                this.qrcodeList = res.rows;
                this.qrcodePage = {
                    total: res.count,
                    pageSize: res.pageSize
                };
            } catch (err) {
                console.log(err);
            }
        },
        // 修改当前场景界面状态
        editDetailStatus(status) {
            this.currDetailStatus = status;
        },
        // 返回 / 取消
        createBack(currDetail) {
            const curr = _.find(this.detailStatus, { status: currDetail.backStatus });
            this.editDetailStatus(curr);
            if (this.currDetailStatus.status === 0) this.currQcrode = {};
            if (currDetail && currDetail.backStatus === 0) this.$emit('backTabDisabled', false);
            this.getGroupQrcodeList();
        },
        // 详情
        toDetail(num, listData) {
            const curr = _.find(this.detailStatus, { status: num });
            this.editDetailStatus(curr);
            if (listData) this.currQcrode = listData;
            this.$emit('backTabDisabled', true);
            this.currDetailStatus.show = true;
        },
        // 翻页
        changePagination(pagination, filters, sorter, currentDataSource) {
            const curr = this.currDetailStatus;
            // 群码翻页
            this.qrcodeParams.page = pagination.current;
            this.getGroupQrcodeList();
        },
        // 下载图片
        async downloadImg(record) {
            if (!record || !record.id) return this.$message.error('下载员工码传参错误。');
            try {
                const res = await api.downloadGroupQrcode({ groupId: record.id });
                if (!res) return;
                if (record.qrcode) {
                    const arr = record.qrcode.split('.');
                    const format = '.' + arr[arr.length - 1];
                    this.downImgFile(record.name + format, res);
                } else {
                    return this.$message.error('群码还没生成');
                }
            } catch (err) {
                console.log(err);
            }
        },
        // 文件流下载方法
        downImgFile(file_name, content) {
            const csvData = new Blob([content]);
            // for IE
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(csvData, file_name);
            }
            // for Non-IE (chrome, firefox etc.)
            else {
                let a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                const url = window.URL.createObjectURL(csvData);
                a.href = url;
                a.download = file_name;
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            }
        },
        // 群码详情组件回调
        backStatus(data) {
            console.log('群码详情组件回调1', data);
            if (data) {
                this.createBack(data);
            }
        },
        toChat(num, listData) {
            console.log('群码详情组件回调2', num, listData);
            if (num || num === 0) {
                this.toDetail(num, listData);
                if (num === 0) {
                    // 返回客户群码列表，清空数据
                    this.currQcrode = {};
                    this.$emit('backTabDisabled', false);
                    this.getGroupQrcodeList();
                }
            }
        },
        changePagination(e) {
            this.qrcodeParams.page = e.current;
            this.getGroupQrcodeList();
        }
    }
};
</script>

<style scoped>
#groupChat .margin_bottom_15 {
    margin-bottom: 15px;
}
#groupChat .btn {
    cursor: pointer;
}
</style>
